module.exports = __webpack_public_path__ + "img/floor6.de0e8c0c.jpg";